import React from 'react'
import { useNavigation } from '@react-navigation/native'
import { useDispatch } from 'APP/Hooks/redux'
import ServiceAuthenticationError from 'APP/Components/ServiceAuthenticationError'
import StartupActions from 'APP/Redux/StartupRedux'
import I18n from 'APP/I18n'
import { Images } from 'APP/Themes'

const StartupServiceAuthenticationErrorScreen = () => {
  const dispatch = useDispatch()
  const navigation = useNavigation()

  const retryStartup = () => {
    navigation.reset({ index: 0, routes: [{ name: 'loading' }] })
    dispatch(StartupActions.fullStartup())
  }

  const goToLogin = () => {
    navigation.navigate('welcome', { openUniversalLogin: true })
  }

  return (
    <ServiceAuthenticationError
      headerText={I18n.t('LoginErrorScreen.title')}
      subHeaderText={I18n.t('LoginErrorScreen.subtitle')}
      returnButtonText={I18n.t('LoginErrorScreen.login')}
      screenIconOverride={Images.logoBlue}
      onRetry={retryStartup}
      onReturn={goToLogin}
    />
  )
}

export default StartupServiceAuthenticationErrorScreen
